export { GTMServiceEntrypoint } from './gtmServiceEntry';
